/**
 * Canonical hub support ticket status meta for the Admin tickets UI.
 * Keep in sync with workflow.hub_support_ticket_status_meta and
 * src/hub-support-ticket/hub-support-ticket-status-meta.ts.
 */

import type { HubSupportTicketStatusMetaRow } from "@/lib/hubSupportTicketStatus";

export const HUB_SUPPORT_TICKET_STATUS_META: HubSupportTicketStatusMetaRow[] = [
  {
    status: "open",
    description: "Untriaged; cause or next step unknown.",
    sort_order: 10,
    may_close: false,
  },
  {
    status: "planned",
    description: "Understood; fix to be worked on later.",
    sort_order: 20,
    may_close: false,
  },
  {
    status: "in_progress",
    description: "Active work or remaining steps.",
    sort_order: 30,
    may_close: false,
  },
  {
    status: "pr_submitted",
    description: "Work complete; needs review, verification, and merge.",
    sort_order: 40,
    may_close: false,
  },
  {
    status: "pending_deploy",
    description: "Fix merged to dev; production ship in progress.",
    sort_order: 45,
    may_close: false,
  },
  {
    status: "pending_verification",
    description: "Work complete and deployed; waiting for reporter confirmation or feedback.",
    sort_order: 50,
    may_close: false,
  },
  {
    status: "resolved",
    description: "Fix or suggestion complete and deployed.",
    sort_order: 60,
    may_close: true,
  },
  {
    status: "declined",
    description: "Reviewed; we are not implementing this.",
    sort_order: 70,
    may_close: true,
  },
];
